import { HTMLAttributes } from 'react';
import { CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

type Props = HTMLAttributes<HTMLDivElement>;
export default function Spinner({ className, ...props }: Props) {
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, className)} {...props}>
      <CircularProgress />
    </div>
  );
}
